export default {
  lighthouse: {
    apiHost: 'http://localhost:8080',
  },
};
